import questionnairesService from '@/api/questionnaire-service';
import { removeArrayItem, updateArrayItem } from '@/util/array';
import eventBus, { OPEN_SNACKBAR, openConfirmDialog } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

const getDefaultFormItem = () => ({});

export const initialQuestionnairesFilterParams = () => ({});

const state = {
  questionnaires: [],
  newQuestionnaire: getDefaultFormItem(),
  editedQuestionnaire: {},
  questionnaireValidationErrors: {},
  questionnairesFilterParams: initialQuestionnairesFilterParams(),
};

const mutations = {
  SET_QUESTIONNAIRES(state, data) {
    state.questionnaires = data;
  },

  SET_FILTER_PARAMS(state, params) {
    state.questionnairesFilterParams = params;
  },

  STORE_QUESTIONNAIRE(state, questionnaire) {
    state.questionnaires = [...state.questionnaires, questionnaire];
    state.newQuestionnaire = getDefaultFormItem();
    state.questionnaireValidationErrors = {};
  },

  SET_EDITED_QUESTIONNAIRE(state, questionnaire) {
    state.questionnaireValidationErrors = {};
    state.editedQuestionnaire = JSON.parse(JSON.stringify(questionnaire));
  },

  UPDATE_QUESTIONNAIRE(state, questionnaire) {
    state.questionnaires = updateArrayItem(state.questionnaires, questionnaire);
  },

  DELETE_QUESTIONNAIRE(state, questionnaire) {
    state.questionnaires = removeArrayItem(state.questionnaires, questionnaire);
  },

  SET_QUESTIONNAIRE_VALIDATION_ERRORS(state, validationErrors) {
    state.questionnaireValidationErrors = validationErrors;
  },

  CLEAR_QUESTIONNAIRE_VALIDATION_ERRORS(state, field) {
    delete state.questionnaireValidationErrors[field];
  },

  REORDER_QUESTIONNAIRES(state, questionnaires) {
    state.questionnaires = questionnaires;
  },
};

const actions = {
  fetchQuestionnaires({ state, commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return questionnairesService.getPage(params).then((res) => {
      commit('SET_QUESTIONNAIRES', res.data);
    });
  },

  storeQuestionnaire({ commit }, questionnaire) {
    return questionnairesService
      .create(questionnaire)
      .then((res) => {
        commit('STORE_QUESTIONNAIRE', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('questionnaire_created'));
        return res;
      })
      .catch((err) => {
        commit('SET_QUESTIONNAIRE_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  editQuestionnaire({ state, commit }, questionnaireId) {
    const questionnaire = state.questionnaires?.find((s) => s.id === questionnaireId);
    if (questionnaire) {
      commit('SET_EDITED_QUESTIONNAIRE', questionnaire);
      return Promise.resolve(questionnaire);
    }
    return questionnairesService.getById(questionnaireId).then((res) => {
      commit('SET_EDITED_QUESTIONNAIRE', res.data);
      return res.data;
    });
  },

  updateQuestionnaire({ commit }, questionnaire) {
    return questionnairesService
      .update(questionnaire)
      .then((res) => {
        commit('UPDATE_QUESTIONNAIRE', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('questionnaire_updated'));
      })
      .catch((err) => {
        commit('SET_QUESTIONNAIRE_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  deleteQuestionnaire({ commit }, questionnaire) {
    openConfirmDialog({
      title: i18n.t('confirm_questionnaire_delete'),
    }).then((confirmed) => {
      if (!confirmed) {
        return;
      }
      questionnairesService.delete(questionnaire).then(() => {
        commit('DELETE_QUESTIONNAIRE', questionnaire);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('questionnaire_deleted'));
      });
    });
  },

  reorderQuestionnaires({ commit }, questionnaireIds) {
    return questionnairesService.reorder(questionnaireIds).then((res) => {
      commit('REORDER_QUESTIONNAIRES', res.data);
      return res.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
